<template>
  <div class="list-item">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="list-item__wrapper"
      @click="handleSelectService(item)"
    >
      <div class="list-item__title">
        {{ item.currency }}
      </div>
      <div
        v-if="selected"
        class="radio-pointer"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            label: "test"
          }
        ];
      }
    }
  },
  computed: {
    selected() {
      return true;
    }
  },
  methods: {
    handleSelectService(service) {
      this.$emit("selected", service);
    }
  }
};
</script>

<style>
</style>
